import DpItemPerformance from './ItemPerformance/DpItemPerformance.i18n.en';
import DpTeacherFeedback from './TeacherFeedback/DpTeacherFeedback.i18n.en';
import DpPerformanceByItem from './StudentDetail/DpStudentDetail.i18n.en';
import DpStudentsDetails from './ScoringStatus/DpScoringStatus.i18n.en';
export default {
  attemptReport: {
    title: '{{name}} Report | Great Minds Digital',
    backAssessmentsAriaLabel: 'Button, Back to all assessments',
    ...DpItemPerformance,
    ...DpTeacherFeedback,
    ...DpPerformanceByItem,
    ...DpStudentsDetails
  }
};